<app-loading-spinner label="Signing in..." [size]="80" [fontSize]="32" color="warn"></app-loading-spinner>
